import { InjectionToken } from '@angular/core';

import { ActionType } from '@ngrx/store';

export const IntegrationsMailboxLinkInsertedActionToken = new InjectionToken<ActionType<any>>(
  'IntegrationsMailboxLinkInsertedActionToken',
);
